import { css } from "@emotion/css";
import { type PrimaryPageAction, EmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { ChannelResource, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { ProjectEphemeralEnvironmentsEmptyStateIllustration } from "./ProjectEphemeralEnvironmentsEmptyStateIllustration";
type ProjectEphemeralEnvironmentsOnboardingProps = {
    project: ProjectResource;
    channels: ChannelResource[];
};
export function ProjectEphemeralEnvironmentsOnboarding({ project, channels }: ProjectEphemeralEnvironmentsOnboardingProps) {
    const ephemeralEnvironmentChannel = channels.find((channel) => channel.Type === "EphemeralEnvironment");
    const primaryAction: PrimaryPageAction = {
        label: ephemeralEnvironmentChannel ? "Create Release" : "Configure Channel",
        path: ephemeralEnvironmentChannel
            ? links.createReleasePage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }, { channelId: ephemeralEnvironmentChannel.Id })
            : links.channelsPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }),
        type: "navigate",
    };
    const description = ephemeralEnvironmentChannel ? (<div className={styles.description}>
            <div>Automatically spin up test environments while keeping your infrastructure costs down.</div>
            <div>Create a release to automatically provision a new environment.</div>
        </div>) : (<div className={styles.description}>
            <div>Automatically spin up test environments while keeping your infrastructure costs down.</div>
            <div>Configure a new channel to enable Ephemeral Environments.</div>
        </div>);
    return <EmptyStateOnboarding description={description} primaryAction={primaryAction} title="Gain confidence in your changes with test environments on demand" image={<ProjectEphemeralEnvironmentsEmptyStateIllustration />}/>;
}
const styles = {
    description: css({
        display: "flex",
        flexDirection: "column",
        gap: space[4],
    }),
};
